import React from 'react';
import { Box, Typography } from '@mui/material';
import Image from '../../../image/Image';

const CustomSettingsTitle = ({
    title,
    description = '',
    link,
    icon,
}: {
    title: string;
    description?: string;
    link?: string;
    icon?: string;
}) => {

    const onNameClick = () => {
        if (link) {
            window.open(link, '_blank');
        }
    };

    return (
        <Box>
            {icon && (
                <Image src={icon} alt={title} className="nameWithIcon_icon"/>
            )}
            <Typography
                sx={{
                    fontSize: { xs: 28, md: 38 },
                    lineHeight: 1.2,
                    fontWeight: 700,
                    color: '#1e2f46',
                    mb: 1,
                    display: 'inline',
                }}
                onClick={onNameClick}
                title={link ?? title}
                className={link ? 'is-link' : ''}
            >
                {title}
            </Typography>

            <Typography
                sx={{
                    fontSize: { xs: 12, md: 16 },
                    color: '#667892',
                    lineHeight: 1.5,
                }}
            >
                {description}
            </Typography>
        </Box>
    );
};

export default CustomSettingsTitle;